import { GeneralModel } from "../models";

export class FromPrintViewModel extends GeneralModel{
    numOrder:number;
    isPublic:boolean;
    formPrintBody:string;
    formPrintTypeId:number;
}